import DiscountPackageIcon from 'components/atoms/SVG/DiscountPackageIcon';
import Banner from 'components/molecules/Banner/Banner.component';
import { getMonthlyAmount } from 'components/pages/Subscriptions/Subscription.helper';
import {
  AppBannersContext,
  BANNERS_STORAGE_KEYS,
} from 'contexts/AppBannersProvider';
import { useGroupSubscriptionPlans } from 'hooks/Subscriptions';
import { useContext, type FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { SubscriptionPlan } from 'types/subscriptions.types';
import type { AvailableCountries } from 'types/users.types';
import { SubscriptionPlanNameEnum } from 'types/users.types';
import formatMoney from 'utils/formatMoney';

const PRODiscountBanner: FC<{ country?: AvailableCountries }> = () => {
  const { t } = useTranslation();

  const { dismissBanner } = useContext(AppBannersContext);

  const subscriptionPlans = useGroupSubscriptionPlans();

  const pro12 = subscriptionPlans.data?.find(
    (plan: SubscriptionPlan) =>
      plan.nickname === SubscriptionPlanNameEnum.pro12,
  );

  if (!pro12 || subscriptionPlans.isLoading) return null;

  const PROPlanPrice = Math.round(
    getMonthlyAmount('year', pro12?.amount as number),
  );

  return (
    <Banner
      Icon={DiscountPackageIcon}
      title={t('subscriptions.discount_generic_disclaimer.title', {
        price: formatMoney(PROPlanPrice),
        percent: 35,
        planName: t(SubscriptionPlanNameEnum.pro12),
      })}
      href="/subscriptions"
      linkLabel={t('subscriptions.discount_generic_disclaimer.cta')}
      onDismiss={() =>
        dismissBanner(
          BANNERS_STORAGE_KEYS.GERMAN_PRO_PLAN_DISCOUNT_BANNER_DISMISS_KEY,
        )
      }
    />
  );
};

export default PRODiscountBanner;
